module.exports = __webpack_public_path__ + "img/xcxbanner.5c6cc490.png";